// extracted by mini-css-extract-plugin
export default {"textArea":"ErrorPage_textArea__+wV5S","head1":"ErrorPage_head1__zaCkC"};